<template>
    <ItemIndex
        :singular-name="singularName"
        :plural-name="pluralName"
        :item-type="indexType"
    >
        <template>
            <ItemIndexFilterNotification
                :index-type="indexType"
                :show="filter.show"
                :type="filter.type"
                :term="filter.term"
            />
            <v-data-table
                :search="searchTerm"
                :headers="headers"
                :items="items"
                :items-per-page="10"
                :loading="tableLoading"
            >
                <template #item.name="{ item }">
                    <v-btn
                        x-small
                        :to="'/field/edit/' + item.id"
                        color="primary"
                    >
                        {{ item.name }}
                        <v-icon
                            right
                            x-small
                        >
                            fas fa-edit
                        </v-icon>
                    </v-btn>
                </template>
                <template #item.card.section.step.name="{ item }">
                    <span v-if="item.card.section">
                        <v-btn
                            x-small
                            color="secondary"
                            @click="filterIndex('Step', item )"
                        > <!--, item.card.section.step.id -->
                            {{ item.card.section.step.name }}
                        </v-btn>
                    </span>
                </template>
                <template #item.card.section.name="{ item }">
                    <span v-if="item.card.section">
                        <v-btn
                            type="button"
                            x-small
                            color="secondary"
                            @click="filterIndex('Section', item)"
                        ><!--, item.card.section.id -->
                            {{ item.card.section.name }}
                        </v-btn>
                    </span>
                </template>
                <template #item.card.name="{ item }">
                    <span v-if="item.card">
                        <v-btn
                            type="button"
                            x-small
                            color="secondary"
                            @click="filterIndex('Card', item)"
                        ><!--, item.card.id -->
                            {{ item.card.name }}
                        </v-btn>
                    </span>
                </template>
                <template #item.card.page.name="{ item }">
                    <span v-if="item.card.page">
                        <v-btn
                            type="button"
                            x-small
                            color="secondary"
                            @click="filterIndex('Page', item)"
                        ><!--, item.card.page.id -->
                            {{ item.card.page.name }}
                        </v-btn>
                    </span>
                </template>
                <template #item.published="{ item }">
                    <v-icon
                        small
                        color="primary"
                        v-if="item.published === 1"
                    >
                        fas fa-check-circle
                    </v-icon>
                    <v-icon
                        small
                        color="error"
                        v-else
                    >
                        fas fa-minus-circle
                    </v-icon>
                </template>
            </v-data-table>
        </template>
    </ItemIndex>
</template>

<script>
import ItemIndexBoilerplate from '@/views/Admin/Config/Commonn/ItemIndexBoilerplate';
export default {
    mixins: [ ItemIndexBoilerplate ],

    data() {
        return {
            indexType: 'field',
            singularName: 'Field',
            pluralName: 'Fields',
            responseObject: 'fields',
            headers: [
                {
                    text: 'Name',
                    value: 'name',
                },
                {
                    text: 'Step',
                    value: 'card.section.step.name',
                },
                {
                    text: 'Section',
                    value: 'card.section.name',
                },
                {
                    text: 'Card',
                    value: 'card.name',
                },
                {
                    text: 'Page',
                    value: 'card.page.name',
                },
                {
                    text: 'Level',
                    value: 'level',
                },
                {
                    text: 'Order',
                    value: 'order',
                },
                {
                    text: 'Published',
                    value: 'published',
                    align: 'right',
                },
            ],
        };
    },
};
</script>
